import React, { useState } from 'react';
import Input from 'components/ui/Input';
import { Checkbox } from 'components/ui/Checkbox';
import Icon from 'components/AppIcon';

const ServiceDescriptionSection = ({ title, description, additionalDetails, onChange, errors }) => {
  const [showAdditionalDetails, setShowAdditionalDetails] = useState(false);
  
  const maxDescriptionLength = 500;
  const maxAdditionalDetailsLength = 1000;
  const descriptionLength = description?.length || 0;
  const additionalDetailsLength = additionalDetails?.length || 0;

  const handleCheckboxChange = (checked) => {
    setShowAdditionalDetails(checked);
    if (!checked) {
      onChange('additionalDetails', '');
    }
  };

  const handleAdditionalDetailsChange = (e) => {
    const value = e?.target?.value || '';
    if (value?.length <= maxAdditionalDetailsLength) {
      onChange('additionalDetails', value);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
          <Icon name="FileText" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-foreground">Descrizione del Servizio</h2>
          <p className="text-sm text-muted-foreground">Fornisci i dettagli della tua richiesta</p>
        </div>
      </div>

      <div className="space-y-4">
        <Input
          label="Titolo della Richiesta"
          placeholder="Es: Riparazione impianto elettrico in cucina"
          value={title}
          onChange={(e) => onChange('title', e?.target?.value)}
          error={errors?.title}
          required
        />

        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground">
            Descrizione
            <span className="text-destructive ml-1">*</span>
          </label>
          <textarea
            className="flex min-h-[120px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 resize-none"
            placeholder="Descrivi il servizio di cui hai bisogno"
            value={description}
            onChange={(e) => onChange('description', e?.target?.value)}
            maxLength={maxDescriptionLength}
            rows={5}
            required
          />
          <div className="flex items-center justify-end text-xs">
            <span className={`font-medium ${
              descriptionLength > maxDescriptionLength * 0.9
                ? 'text-warning' : 'text-muted-foreground'
            }`}>
              {descriptionLength}/{maxDescriptionLength}
            </span>
          </div>
          {errors?.description && (
            <p className="text-sm text-destructive">{errors?.description}</p>
          )}
        </div>

        {/* Checkbox for additional details */}
        <div className="flex items-start gap-3 pt-2">
          <Checkbox
            id="additionalDetailsCheckbox"
            checked={showAdditionalDetails}
            onCheckedChange={handleCheckboxChange}
          />
          <label
            htmlFor="additionalDetailsCheckbox"
            className="text-sm font-medium text-foreground cursor-pointer select-none"
          >
            Aggiungi ulteriori dettagli
          </label>
        </div>

        {/* Optional additional details field */}
        {showAdditionalDetails && (
          <div className="space-y-2 animate-in fade-in slide-in-from-top-2 duration-300">
            <label className="text-sm font-medium text-foreground">
              Dettagli aggiuntivi
              <span className="text-muted-foreground ml-1 font-normal">(Opzionale)</span>
            </label>
            <textarea
              className="flex min-h-[200px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 resize-none"
              placeholder="Aggiungi ulteriori dettagli, specifiche tecniche, materiali preferiti, vincoli particolari, ecc."
              value={additionalDetails}
              onChange={handleAdditionalDetailsChange}
              maxLength={maxAdditionalDetailsLength}
              rows={8}
            />
            <div className="flex items-center justify-end text-xs">
              <span className={`font-medium ${
                additionalDetailsLength > maxAdditionalDetailsLength * 0.9
                  ? 'text-warning' : 'text-muted-foreground'
              }`}>
                {additionalDetailsLength}/{maxAdditionalDetailsLength}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ServiceDescriptionSection;